import { API } from "@/constants";
import { resolveApiUrl } from "@/config/localDev";
import { get, post } from "./api";

interface IWarehouseConfig {
  project_id: string;
  dataset: string;
}

interface IWarehousePayload {
  name: string;
  user_id: number;
  warehouse_type: string;
  config: IWarehouseConfig;
}

interface IWarehouse extends IWarehousePayload {
  id: number;
}

export const getWarehouse = async (userId: number): Promise<IWarehouse> => {
  return get<IWarehouse>(`${API.WAREHOUSES}?user_id=${userId}`);
};

export const getEnabledWarehouse = async (
  userId: number
): Promise<IWarehouse[]> => {
  return get<IWarehouse[]>(
    `${resolveApiUrl(
      import.meta.env.VITE_INSIGHTS_SUBSCRIPTION_API_URL
    )}/warehouse/enabled/${userId}`
  );
};

export const postWarehouse = async (
  payload: IWarehousePayload
): Promise<IWarehouse> => {
  return post<IWarehouse>(API.WAREHOUSES, payload);
};
